// 根据环境变量确定资源路径
const publicPath =
  process.env.NODE_ENV === "development"
    ? "/api" // 开发环境使用代理路径
    : "https://pcx.tiarigieit.jp"; // 生产环境使用完整URL
const asset = (path = "") => publicPath + path;
const imagePlaceholder = (size = "square") =>
  size == "square"
    ? "/assets/img/placeholder.jpg"
    : "/assets/img/placeholder-rect.jpg";

export default {
  publicPath,
  asset,
  imagePlaceholder,
};
